import React, { useState } from 'react';
import LoginForm from './LoginForm';
import FullVersionForm from './FullVersionForm';

export default function ProtectedFullVersion() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
    }
  };

  if (isAuthenticated) {
    return <FullVersionForm />;
  }

  return <LoginForm onLogin={handleLogin} />;
}
